import React from "react";
import { Link } from "react-router-dom";
import { COLORS, TYPOGRAPHY, SPACING, SHADOWS, RADIUS, TRANSITIONS, GRADIENTS } from '../constants/designTokens';
import { CATEGORIES } from '../constants/siteConfig';

const services = CATEGORIES.map((cat) => ({
	icon: <i className={cat.icon} style={{ fontSize: "1.9rem" }} aria-hidden="true"></i>,
	title: cat.title,
	description: cat.short,
	brands: cat.brands,
	link: cat.path,
}));

const OurServices = () => (
	<section
		id="services"
		className="services-section py-5"
		style={{
			background: COLORS.background.light,
			position: "relative",
		}}
	>
		<style>{`
            .services-section h2 {
                color: ${COLORS.primary.dark};
                font-weight: ${TYPOGRAPHY.fontWeight.bold};
                margin-bottom: ${SPACING['3xl']};
                text-align: center;
                position: relative;
            }
            .services-section h2::after {
                content: '';
                position: absolute;
                bottom: -8px;
                left: 50%;
                transform: translateX(-50%);
                width: 60px;
                height: 3px;
                background: ${GRADIENTS.primary};
                border-radius: ${RADIUS.sm};
            }
            .services-row {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: ${SPACING.lg};
                max-width: 1200px;
                margin: 0 auto;
            }
            .service-card {
                background: ${COLORS.background.white};
                border: 2px solid transparent;
                border-radius: ${RADIUS.xl};
                box-shadow: ${SHADOWS.md};
                padding: ${SPACING.xl} ${SPACING.lg};
                transition: ${TRANSITIONS.all};
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                position: relative;
                overflow: hidden;
            }
            .service-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 4px;
                background: ${GRADIENTS.teal};
                transform: translateX(-100%);
                transition: transform 0.4s ease;
            }
            .service-card:hover {
                transform: translateY(-8px);
                box-shadow: ${SHADOWS['2xl']};
                border-color: rgba(64, 168, 196, 0.3);
            }
            .service-card:hover::before {
                transform: translateX(0);
            }
            .service-icon {
                background: ${GRADIENTS.teal};
                border-radius: ${RADIUS.full};
                width: 70px;
                height: 70px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: ${COLORS.text.white};
                font-size: 2rem;
                margin-bottom: ${SPACING.lg};
                box-shadow: 0 4px 20px rgba(64, 168, 196, 0.3);
                transition: ${TRANSITIONS.all};
            }
            .service-card:hover .service-icon {
                transform: scale(1.1) rotate(5deg);
                box-shadow: 0 6px 25px rgba(64, 168, 196, 0.4);
            }
            .service-title {
                font-size: ${TYPOGRAPHY.fontSize.lg};
                font-weight: ${TYPOGRAPHY.fontWeight.bold};
                color: ${COLORS.primary.dark};
                margin-bottom: ${SPACING.md};
                line-height: ${TYPOGRAPHY.lineHeight.tight};
            }
            .service-desc {
                color: ${COLORS.text.primary};
                font-size: ${TYPOGRAPHY.fontSize.base};
                line-height: ${TYPOGRAPHY.lineHeight.relaxed};
                flex-grow: 1;
                margin-bottom: ${SPACING.md};
            }
            .service-brands {
                color: ${COLORS.primary.teal};
                font-size: ${TYPOGRAPHY.fontSize.xs};
                font-weight: ${TYPOGRAPHY.fontWeight.semibold};
                margin-bottom: ${SPACING.lg};
                letter-spacing: 0.2px;
            }
            .service-btn {
                background: ${GRADIENTS.teal};
                border: none;
                border-radius: ${RADIUS.lg};
                padding: ${SPACING.sm} ${SPACING.lg};
                color: ${COLORS.text.white};
                font-weight: ${TYPOGRAPHY.fontWeight.semibold};
                font-size: ${TYPOGRAPHY.fontSize.sm};
                text-decoration: none;
                transition: ${TRANSITIONS.all};
                box-shadow: ${SHADOWS.sm};
                margin-top: auto;
            }
            .service-btn:hover {
                background: linear-gradient(135deg, ${COLORS.primary.lightTeal} 0%, ${COLORS.primary.teal} 100%);
                transform: translateY(-2px);
                box-shadow: ${SHADOWS.md};
                color: ${COLORS.text.white};
                text-decoration: none;
            }
            .contact-btn {
                background: linear-gradient(135deg, ${COLORS.primary.dark} 0%, #1a365d 100%);
                border: 2px solid ${COLORS.primary.teal};
            }
            .contact-btn:hover {
                background: ${GRADIENTS.teal};
                border-color: ${COLORS.primary.teal};
                transform: translateY(-2px);
            }
            
            @media (max-width: 992px) {
                .services-row {
                    grid-template-columns: repeat(2, 1fr);
                    gap: ${SPACING.lg};
                }
            }
            @media (max-width: 768px) {
                .services-row {
                    grid-template-columns: 1fr;
                    gap: ${SPACING.lg};
                }
                .service-card {
                    padding: ${SPACING.lg} ${SPACING.md};
                }
                .service-icon {
                    width: 60px;
                    height: 60px;
                    font-size: 1.7rem;
                }
                .service-title {
                    font-size: ${TYPOGRAPHY.fontSize.md};
                }
                .service-desc {
                    font-size: ${TYPOGRAPHY.fontSize.sm};
                }
            }
        `}</style>
		<div className="container">
			<h2>Our Spare Parts</h2>
			<div className="services-row stagger-container">
				{services.map((service, idx) => (
					<div
						className="service-card scale-in animate-on-scroll"
						key={idx}
						style={{ '--stagger-index': idx }}
					>
						<div className="service-icon">
							{service.icon}
						</div>
						<div className="service-title">{service.title}</div>
						<div className="service-desc">{service.description}</div>
						{service.brands && (
							<div className="service-brands">{service.brands}</div>
						)}
						<Link
							to={service.link}
							className="service-btn"
						>
							View Parts
						</Link>
					</div>
				))}
			</div>
		</div>
	</section>
);

export default OurServices;
